export const parseNetworkError = err => {
    return err.networkError
      ? err.networkError.result.errors[0].message
      : "Sorry! Something went wrong while placing your order. Please try again later.";
  };